export default __webpack_public_path__ + "static/media/fr-flag.40c79af5.svg";